import {z} from 'zod'
import {validateState} from '../ValidateState.ts'
import {PlayerColor} from '../PlayerState.ts'

// TileEdgeDirection: https://prntscr.com/w5qsqr
export enum TileEdgeDirection {
    NorthWest = 0,
    West = 1,
    SouthWest = 2,
}

export enum TileEdgeType {
    Road = 1,
    Ship = 2,
}

export const tileEdgeStateSchema = z
    .object({
        x: z.number().int().readonly(),
        y: z.number().int().readonly(),
        z: z.enum(TileEdgeDirection).readonly(),
        owner: z.enum(PlayerColor).exclude(['None']).optional(),
        type: z.enum(TileEdgeType).optional(),
    })
    .strict()

export type TileEdgeState = z.infer<typeof tileEdgeStateSchema>

export function validateTileEdgeState(data: unknown) {
    return validateState(tileEdgeStateSchema, data)
}

export const tileEdgeStatePartialSchema = tileEdgeStateSchema.partial().refine((obj) => Object.keys(obj).length > 0, {
    message: 'At least one property must be provided',
})

export type TileEdgeStatePartial = z.infer<typeof tileEdgeStatePartialSchema>

export function validateTileEdgeStatePartial(data: unknown) {
    return validateState(tileEdgeStatePartialSchema, data)
}
